import React from 'react';
import ModalAtivarItinerario from './ModalAtivarItinerario';
import ModalInativarItinerario from './ModalInativarItinerario'

export class DetalhesRotaItinerario extends React.Component {

    inputCheckInativo(itinerarios) {
        return (
            <button type="submit"
                data-toggle="modal"
                data-target="#modalInativarVendaSiteItinerario"
                className="btn btn-danger internet ml-2"
                disabled={!itinerarios.filter(it => it.habilitadoSite === true).length > 0}
                onClick={() => {this.props.selecionarItinerario(itinerarios)
                    this.props.selecionarRota(this.props.rota)}}>Inativar
            </button>
        )
    }

    inputCheckAtivo(itinerarios) {
        return (
            <button type="submit"
                data-toggle="modal"
                data-target="#modalAtivarVendaSiteItinerario"
                className="btn btn-success internet ml-2"
                disabled={!itinerarios.filter(it => it.habilitadoSite === false).length > 0}
                onClick={() => {this.selecionarItinerario(itinerarios)
                    this.props.selecionarRota(this.props.rota)}}>Ativar
            </button>
        )
    }

    dividirItinerariosParaATabela(itinerarios, ativo) {
        if (itinerarios) {
            if (ativo) {
                itinerarios = itinerarios.filter(it => it.habilitadoSite === true);
            } else {
                itinerarios = itinerarios.filter(it => it.habilitadoSite !== true);
            }
            let novoArray = [];
            let corte = 3;
            if (!ativo) {
                corte = 2;
            }
            for (let i = 0; i < itinerarios.length; i = i + corte) {
                novoArray.push(itinerarios.slice(i, i + corte));
            }
            return this.montarTabela(novoArray);
        }
    }

    montarTabela(array) {
        return array.map((it, index) => <tr key={index}>
            {it.map((itinerario, indice) => <td colSpan={4} className='text-center' key={indice}>
                {itinerario.dataHoraPartida}</td>
            )}
        </tr>
        );
    }

    selecionarItinerario(itinerarios) {
        this.props.selecionarItinerario(itinerarios)
    }

    exibirTrecho() {
        const trechos = this.props.rota.trechos;
        const itinerarios = this.props.rota.itinerarios

        return <table className='table-trechos'>
            <div id='trechos' className='trechos'>
                <thead style={{ backgroundColor: '#ffffff66' }}>
                    <tr>
                        <th colSpan={4} className='text-center'><strong></strong></th>
                        <th colSpan={4} className='text-center'><strong>Trecho</strong></th>
                        <th colSpan={4} className='text-center'><strong>Horário</strong></th>
                        <th colSpan={4} className='text-center'><strong>Quilometragem</strong></th>
                    </tr>
                </thead>
                <tbody id='trecho'>
                    {trechos && trechos.length && trechos.sort((a, b) => a.ordem - b.ordem).map((trecho, indice) =>
                        <tr key={indice}>
                            <td colSpan={4} className='text-center'>{trecho.ordem}</td>
                            <td colSpan={4} className='text-center'>{trecho.cidadeDestino.nomeComUf}</td>
                            <td colSpan={4} className='text-center'>{trecho.duracao}</td>
                            <td colSpan={4} className='text-center'>{trecho.quilometragem}</td>
                        </tr>)}
                </tbody>
            </div>
            <div className='ativo ml-4 mr-4'>
                <thead style={{ backgroundColor: '#ffffff66' }}>
                    <th colSpan={18} className='text-center'><strong>Itinerários Ativos</strong>
                    {this.inputCheckInativo(itinerarios)}
                    </th>
                </thead>
                <tbody>
                    {this.dividirItinerariosParaATabela(itinerarios, true)}
                </tbody>
            </div>
            <div className='inativo'>
                <thead style={{ backgroundColor: '#ffffff66' }}>
                    <th colSpan={18} className='text-center'><strong>Itinerários Inativos</strong>
                        {this.inputCheckAtivo(itinerarios)}
                    </th>
                </thead>
                <tbody>
                    {this.dividirItinerariosParaATabela(itinerarios, false)}
                </tbody>
            </div>
        </table>
    }

    render() {
        if (!this.props.rota.exibirDetalhe || this.props.rota.itinerarios === undefined) {
            return ''
        }

        if (this.props.rota.itinerarios && this.props.rota.itinerarios.length > 0 || this.props.rota.trechos && this.props.rota.trechos.length > 0) {
            return (
                <div>
                    <div className="card-body cinza-zebrado table-responsive-sm">
                        <table className="table table-sm table-bordered">
                            {this.exibirTrecho()}
                        </table>
                    </div>
                    <ModalAtivarItinerario/>
                    <ModalInativarItinerario/>
                </div>
            )
        }
        return (
            <div>
                <div className="card-body cinza-zebrado table-responsive-sm">
                    <a><b>Rota não possui trechos e itinerários</b></a>
                </div>
            </div>
        )
    }
}